module.exports = __webpack_public_path__ + "assets/images/project/head/Howey_Ou.jpg?v=dd76e26f";